<script>
    import {onMount} from "svelte";
    import {Link, navigate} from "svelte-routing";
    import moment from "moment-timezone";
    import TopMenu from "../components/TopMenu.svelte";
    import Footer from "../components/Footer.svelte";
    import {network, store} from "../stores";

    const user = store('credential', 'getAuth');
    let list = [];
    export let vid;

    let currentDate = moment().utc();
    let dataS = currentDate.clone().startOf('month').subtract(1, 'month');
    let dataPo = currentDate.endOf('month');

    let sDate = dataS.format('YYYY-MM-DD');
    let poDate = dataPo.format('YYYY-MM-DD');

    let isLoading = true

    let settings = {
        vid: vid ? Number(vid) : 16,
        idKontr: $user.tip.toLowerCase().includes('администратор') ? -1 :+$user.idkontr,
        idSklad: +$user.idSklad,
        data1: dataS.format('DD.MM.YYYY'),
        data2: dataPo.add(1, 'days').format('DD.MM.YYYY')
    }

    const updateDate = (date) => {
        return moment.utc(date).format('DD.MM.YYYY')
    }

    const setSettingsAndGet = (params = {data1: sDate, data2: poDate}) => {
        if (params?.data1){
            params.data1 = updateDate(params.data1)
        }
        if (params?.data2){
            params.data2 = updateDate(params.data2)
        }
        settings = {...settings, ...params};
        getList()
    }

    const changeVid = (newVid) => {
        navigate(`/list/${newVid}`, {replace: true})
        setSettingsAndGet({vid: newVid})
    }


    const getList = async () => {
        isLoading = true
        const orders = await network.getList(settings)
        list = orders.sort((a, b) => moment(b.data).diff(moment(a.data)));
        isLoading = false
        return
    }

    onMount( async ()=>{
        setSettingsAndGet()
    })


</script>
<style>
    .loading-pulse {
        animation: pulse 1.5s infinite ease-in-out;
    }

    @keyframes pulse {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }

    .spinner-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
    }

    .spinner {
        animation: rotate 2s linear infinite;
        width: 50px;
        height: 50px;
    }

    .spinner .path {
        stroke: #007bff; /* СИНИЙ цвет */
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
</style>
<TopMenu title="Мои заявки" />
<div class="superExtraHeader">
    <div class="row" style="width: 100%">
        <div class="col-3 pb-1"><button type="button" on:click={() => changeVid(16)} style="font-size: 10px;" class="btn {settings.vid === 16 ? 'btn-primary': 'btn-secondary'} btn-block">Черновики</button></div>
        <div class="col-3 pb-1"><button type="button" on:click={() => changeVid(19)} style="font-size: 10px;" class="btn {settings.vid === 19 ? 'btn-primary': 'btn-secondary'} btn-primary btn-block">В работе</button></div>
        <div class="col-6 pb-1">
            <input class="form-control" type="date" id="sDate" bind:value={sDate} on:change={() => setSettingsAndGet()}>
        </div>
        <div class="col-3 "><button type="button" on:click={() => changeVid(12)} style="font-size: 10px;" class="btn {settings.vid === 12 ? 'btn-primary': 'btn-secondary'} btn-block">На складе</button></div>
        <div class="col-3 "><button type="button" on:click={() => changeVid(21)} style="font-size: 10px;" class="btn {settings.vid === 21 ? 'btn-primary': 'btn-secondary'} btn-block">Отгружен.</button></div>
        <div class="col-6">
            <input class="form-control" type="date" id="poDate" bind:value={poDate} on:change={() => setSettingsAndGet()}>
        </div>
    </div>
</div>
<div id="appCapsule" class="super-extra-header-active">
    {#if isLoading}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title loading-pulse">Загрузка</h5>
                    <p class="card-text loading-pulse">
                        Пожалуйста подождите, мы загружаем список ваших заявок..
                    </p>
                    <div class="spinner-container mt-4">
                        <svg class="spinner" viewBox="0 0 50 50">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        {#if list.length > 0}
            <div class="section full">
                <div class="bg-white">
                    <ul class="listview link-listview">
                        {#each list as item}
                            <li>
                                <Link to="/list/{item.vid}/{item.nomer}" class="row py-3">
                                    <div class="col-12">
                                        <div style="right: 0" class="position-absolute text-end top-0">
                                            <span class="text-muted">{moment(item.data).format('DD.MM.YYYY')}</span>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="col-auto"><h4 class="d-inline">#{item.nomerStr} {item.tipIzd}</h4></div>
                                                    </div>
                                                    <div class="col-12">
                                                        <span>{item.name}</span><br>
                                                        <span>{item.nameKontakt}</span><br>
                                                        <span class="text-danger">{item.komment}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <div class="row text-end">
                                                    <div class="col-12">
                                                        {#if +item.summa}
                                                            <div class="chip chip-media">
                                                                <i class="chip-icon bg-primary">
                                                                    <ion-icon name="cash-outline" role="img" class="md hydrated"></ion-icon>
                                                                </i>
                                                                <span class="chip-label">{Number((+item.summa).toFixed(0)).toLocaleString("ru-RU")} ₽</span>
                                                            </div>
                                                        {/if}
                                                        {#if +item.summaOpl}
                                                            <div class="chip chip-media">
                                                                <i class="chip-icon bg-success">
                                                                    <ion-icon name="cash-outline" role="img" class="md hydrated"></ion-icon>
                                                                </i>
                                                                <span class="chip-label">{Number((+item.summaOpl).toFixed(0)).toLocaleString("ru-RU")} ₽</span>
                                                            </div>
                                                        {/if}



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        {/each}
                    </ul>
                </div>
            </div>
            {:else}
                <div class="section mt-2">
                    <div class="card text-center">
                        <div class="card-body p-5">
                            <h5 class="card-title">Ничего не найдено</h5>
                            <p class="card-text">
                                Попробуйте изменить дату или категорию.
                            </p>
                        </div>
                    </div>
                </div>
            {/if}
    {/if}
</div>
<Footer />
